import CommonStudyTypesEvents from "./common/CommonStudyTypesEvents";
import { Container } from "@mui/material";

const StudiesTypePage = () => {
  return(
  <div style={{ paddingTop: "4rem" }}>
    <Container maxWidth="xxl">
      <CommonStudyTypesEvents />
    </Container>
  </div>
  );
};

export default StudiesTypePage;
